import React, { useState, useEffect, useMemo, useContext } from 'react';
import {
    Button,
    Grid,
    List,
    ListItem,
    Divider,
    Typography,
    Box,
    Tabs,
    Tab,
    Paper,
    IconButton,
    Stack,
    InputAdornment,
    Chip,
    ListItemIcon,
    ListItemText,
    ListItemSecondaryAction,
    Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import QueryBuilderIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PersonIcon from '@mui/icons-material/Person';
import DescriptionIcon from '@mui/icons-material/Description';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import WorkIcon from '@mui/icons-material/Work';
import DateRangeIcon from '@mui/icons-material/DateRange';
import BadgeIcon from '@mui/icons-material/Badge';
import HomeIcon from '@mui/icons-material/Home';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import BloodtypeIcon from '@mui/icons-material/Bloodtype';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import dayjs from 'dayjs';

import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import StyledAutocomplete from '../../components/UIComponents/StyledAutocomplete';
import StyledTextField from '../../components/UIComponents/StyledTextField';
import StyledSelect from '../../components/UIComponents/StyledDropDown';
import { useLocation, useNavigate } from "react-router-dom";
import BasicTable from '../../components/Table';
import theme from '../../assets/theme';
import { createEmployee, Employeedetails, getEmployeeDetails, updateEmployee, runReportData, uploadEmployeeFile, uploadEmployeeDocument, getEmployeeAttachments, updateFileAttachment, retrievefile } from '../../service/network';
import { useLoading } from "../../context/loading.context"
import { useNotification } from "../../context/notification.context"
import { AuthContext } from "../../context/auth.context"


const departments = ['Engineering', 'Marketing', 'HR', 'Finance', 'Operations'];
const bloodGroups = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
const statusOptions = ['Active', 'Inactive', 'Left', 'Suspended'];

function AddEmployee() {
    const location = useLocation();
    const navigate = useNavigate();
    const editMode = location.state?.editMode || false;
    const [existingEmployee, setExistingEmployee] = useState(null);

    const employeeId = location.state?.employeeId || null;
    const [tabValue, setTabValue] = useState(0);
    const [attachments, setAttachments] = useState([]);


    const [searchQuery, setSearchQuery] = useState('');
    const [startDate, setStartDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
    const { selLocation } = useContext(AuthContext);
    const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));
    const [allAttendanceData, setAllAttendanceData] = useState([]);
    const [filteredAttendance, setFilteredAttendance] = useState([]);
    const [attendanceStats, setAttendanceStats] = useState({
        workingDays: 0,
        presentDays: 0,
        absentDays: 0,
        leaveDays: 0,
        avgWorkingHours: 0,
        attendanceRate: 0,
        totalOtHours: 0
    });

    useEffect(() => {
        if (editMode && existingEmployee) {
            setEmployeeData(existingEmployee);
        }
    }, [editMode, existingEmployee]);

    const [genderOptions, setGenderOptions] = useState([]);
    const [positionOptions, setPositionOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [BranchOptions, setBranchOptions] = useState([]);
    const [shiftOptions, setShiftOptions] = useState([]);

    const [employmentTypeOptions, setEmploymentTypeOptions] = useState([]);
    const { showLoader, hideLoader } = useLoading();
    const { showNotification } = useNotification();
    const [imageUrl, setImageUrl] = useState(null);


    const [employeeData, setEmployeeData] = useState({
        firstname: editMode ? existingEmployee?.firstname : '',
        lastname: editMode ? existingEmployee?.lastname : '',
        email: '',
        phone: '',
        bio: '',
        employeeId: editMode ? existingEmployee?.employee_id : '',
        dob: "",
        gender: "",
        address: '',
        photo: null,
        department: '',
        position: '',
        employmentType: '',
        hireDate: '',
        shift: "",
        status: '',
        salary: '',
        DOexit: '',
        paddress: "",
        isManager: false,
        notes: '',
        panCardNumber: '',
        aadhaarNumber: '',
        bankAccountNumber: '',
        bankName: '',
        ifscCode: '',
        PF: '',
        UAN: '',
        passbookFile: null,
        panCardFile: null,
        bloodGroup: '',
        emergencyContactperson: '',
        Contactpersonrelationship: '',
        emergencyContact: '',
        documents: []
    });

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleChange = (field, value) => {
        setEmployeeData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const getDocumentViewUrl = (fileUrl) => {
        console.log('Original file URL:', fileUrl); // Debug log
        const viewUrl = `https://oracle.iggietech.in/financials${(fileUrl)}`;
        console.log('Generated view URL:', viewUrl); // Debug log
        return viewUrl;
    };
    const handleClose = () => {
        navigate('/employee/list');
    };
    // Handle document upload
    const handleMultipleDocumentUpload = async (files) => {
        if (!files || files.length === 0 || !editMode || !employeeId) return;

        showLoader();
        try {
            const uploadAndAttachPromises = Array.from(files).map(async (file) => {
                // 1. First upload the file
                const uploadResponse = await uploadEmployeeDocument(file, employeeId);
                const fileData = uploadResponse.data.message;

                // 2. Then attach it to the employee
                await updateFileAttachment({
                    fileName: fileData.name, // Use the 'name' (document ID) not 'file_name'
                    attached_to_doctype: "Employee",
                    attached_to_name: employeeId
                });

                return fileData;
            });

            const uploadedFiles = await Promise.all(uploadAndAttachPromises);

            // Create new attachment objects with view URLs
            const newAttachments = uploadedFiles.map(fileData => ({
                file_name: fileData.file_name,
                file_url: fileData.file_url,
                name: fileData.name,
                is_private: 1,
                creation: new Date().toISOString(),
                view_url: getDocumentViewUrl(fileData.file_url),
                isNew: true // Mark as newly uploaded
            }));

            setAttachments(prev => [...prev, ...newAttachments]);
            showNotification('success', 'Success', 'Documents uploaded and attached successfully');
        } catch (error) {
            console.error('Error uploading documents:', error);
            let errorMessage = 'Failed to upload documents';

            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }

            showNotification('error', 'Upload Failed', errorMessage);
        } finally {
            hideLoader();
        }
    };
    const fetchAttendanceData = async () => {
        if (!editMode || !employeeId) return;

        showLoader();
        try {
            const req_body = {
                report_name: "Shift Attendance",
                filters: {
                    "from_date": dayjs(startDate).format('YYYY-MM-DD'),
                    "to_date": dayjs(endDate).format('YYYY-MM-DD'),
                    "company": selLocation[0],
                    "employee": employeeId
                },
                ignore_prepared_report: false,
                are_default_filters: false
            };

            const response = await runReportData(req_body);

            // Handle the API response structure correctly
            const attendanceData = Array.isArray(response?.data?.message?.result)
                ? response.data.message.result
                : [];

            // Process the data to match our table format
            const processedData = attendanceData.map(item => ({
                date: item.attendance_date ? dayjs(item.attendance_date).format('DD/MM/YYYY') : '-',
                checkIn: item.in_time ? item.in_time.split(' ')[0] : '-', // Extract time part if needed
                checkOut: item.out_time ? item.out_time.split(' ')[0] : '-',
                duration: item.working_hours ? `${item.working_hours}h` : '0h',
                status: item.status || 'Absent',
                otHours: calculateOvertime(item), // New helper function
                otStatus: hasOvertime(item) ?
                    <CheckCircleIcon sx={{ color: theme.palette.green.main }} /> :
                    <CancelIcon sx={{ color: theme.palette.danger.main }} />,
                otHoursValue: calculateOvertimeHours(item) // New helper function
            }));

            setAllAttendanceData(processedData);
            setFilteredAttendance(processedData);
            calculateAttendanceStats(processedData);
        } catch (error) {
            console.error('Error fetching attendance data:', error);
            showNotification('error', 'Error', 'Failed to fetch attendance data');
            setAllAttendanceData([]);
            setFilteredAttendance([]);
            calculateAttendanceStats([]);
        } finally {
            hideLoader();
        }
    };

    const calculateOvertime = (item) => {
        if (!item.shift_actual_start || !item.shift_actual_end) return '0h';

        const shiftStart = new Date(`2000-01-01T${item.shift_start}`);
        const shiftEnd = new Date(`2000-01-01T${item.shift_end}`);
        const actualStart = new Date(`2000-01-01T${item.shift_actual_start}`);
        const actualEnd = new Date(`2000-01-01T${item.shift_actual_end}`);

        const shiftDuration = (shiftEnd - shiftStart) / 3600000; // hours
        const actualDuration = (actualEnd - actualStart) / 3600000;

        const overtime = actualDuration - shiftDuration;
        return overtime > 0 ? `${overtime.toFixed(1)}h` : '0h';
    };

    // Helper function to check if there's overtime
    const hasOvertime = (item) => {
        if (!item.shift_actual_start || !item.shift_actual_end) return false;

        const shiftEnd = new Date(`2000-01-01T${item.shift_end}`);
        const actualEnd = new Date(`2000-01-01T${item.shift_actual_end}`);

        return actualEnd > shiftEnd;
    };

    // Helper function to get overtime hours as number
    const calculateOvertimeHours = (item) => {
        if (!item.shift_actual_start || !item.shift_actual_end) return 0;

        const shiftEnd = new Date(`2000-01-01T${item.shift_end}`);
        const actualEnd = new Date(`2000-01-01T${item.shift_actual_end}`);

        return Math.max(0, (actualEnd - shiftEnd) / 3600000);
    };
    const calculateAttendanceStats = (data) => {
        let presentDays = 0;
        let absentDays = 0;
        let totalOtHours = 0;
        let workingHoursTotal = 0;

        data.forEach(record => {
            if (record.status === 'Present' || record.status === 'Half Day') {
                presentDays += record.status === 'Present' ? 1 : 0.5;

                // Calculate working hours (8 for full day, 4 for half day)
                const hours = record.status === 'Present' ? 8 : 4;
                workingHoursTotal += hours;

                // Sum OT hours
                if (record.otHoursValue) {
                    totalOtHours += record.otHoursValue;
                }
            } else if (record.status === 'Absent') {
                absentDays++;
            }
        });

        const workingDays = data.length;
        const attendanceRate = presentDays > 0 ?
            ((presentDays / (presentDays + absentDays)) * 100).toFixed(1) : 0;
        const avgWorkingHours = presentDays > 0 ?
            (workingHoursTotal / presentDays).toFixed(1) : 0;

        setAttendanceStats({
            workingDays,
            presentDays,
            absentDays,
            avgWorkingHours,
            attendanceRate,
            totalOtHours: totalOtHours.toFixed(1)
        });
    };
    useEffect(() => {
        if (tabValue === 3 && editMode && employeeId) {
            fetchAttendanceData();
        }
    }, [tabValue, startDate, endDate, employeeId]);

    const getAttendanceConfig = (data) => ({
        rows: [
            {
                id: 'date',
                label: 'Date',
                flex: 1,
                minWidth: '130px',
                accessor: 'date',
                align: 'center',
                canSort: false,
            },
            {
                id: 'checkIn',
                label: 'Check-In',
                flex: 1,
                minWidth: '120px',
                accessor: 'checkIn',
                align: 'center',
                canSort: false,
            },
            {
                id: 'checkOut',
                label: 'Check-Out',
                flex: 1,
                minWidth: '120px',
                accessor: 'checkOut',
                align: 'center',
                canSort: false,
            },
            {
                id: 'duration',
                label: 'Duration',
                flex: 1,
                minWidth: '120px',
                accessor: 'duration',
                align: 'center',
                canSort: false,
            },

            {
                id: 'status',
                label: 'Status',
                flex: 1,
                minWidth: '150px',
                accessor: 'status',
                align: 'center',
                canSort: false,
                Cell: ({ row }) => {
                    const displayStatus = row.status === 'On Leave' ? 'Absent' : row.status;
                    let icon, color, bgColor;

                    switch (displayStatus) {
                        case 'Present':
                            icon = <CheckCircleIcon fontSize="small" />;
                            color = '#4caf50';
                            bgColor = '#e8f5e9';
                            break;
                        case 'Absent':
                            icon = <CancelIcon fontSize="small" />;
                            color = '#f44336';
                            bgColor = '#ffebee';
                            break;
                        case 'Half Day':
                            icon = <AccessTimeIcon fontSize="small" />;
                            color = '#2196f3';
                            bgColor = '#e3f2fd';
                            break;
                        default:
                            icon = null;
                    }

                    return (
                        <Chip
                            icon={icon}
                            label={displayStatus}
                            sx={{
                                backgroundColor: bgColor,
                                color: color,
                                fontWeight: 500,
                                px: 1,
                                '.MuiChip-icon': { color: color }
                            }}
                            size="small"
                        />
                    );
                }
            },
        ],
        columns: data,
    });

    const employeeTableConfig = useMemo(() => {
        return getAttendanceConfig(filteredAttendance);
    }, [filteredAttendance]);

    const fetchOptions = async (doctype, setterFunction) => {
        try {
            const queryParams = new URLSearchParams({
                doctype,
                fields: JSON.stringify(['name'])
            });

            const response = await Employeedetails(queryParams.toString());

            if (!response?.data?.message?.values) {
                throw new Error(`No data found for ${doctype}`);
            }

            const options = response.data.message.values.map(v => v[0]);
            setterFunction(options);
        } catch (error) {
            console.error(`Failed to fetch ${doctype} options:`, error);
            setterFunction([]);
        }
    };

    useEffect(() => {
        fetchOptions('Gender', setGenderOptions);
        fetchOptions('Designation', setPositionOptions);
        fetchOptions('Department', setDepartmentOptions);
        fetchOptions('Branch', setBranchOptions);
        fetchOptions('Shift Type', setShiftOptions);


        fetchOptions('Employment Type', setEmploymentTypeOptions);
    }, []);

    const handleFileUpload = async (field, fileOrEvent) => {
        const file = fileOrEvent?.target?.files?.[0] || fileOrEvent;
        if (!file) return;

        try {
            if (field === 'photo') {
                // For new uploads (File/Blob objects)
                if (file instanceof File || file instanceof Blob) {
                    const previewUrl = URL.createObjectURL(file);
                    setImageUrl(previewUrl);
                    setEmployeeData(prev => ({ ...prev, [field]: file }));
                }
                // For existing URLs (string)
                else if (typeof file === 'string') {
                    setImageUrl(file);
                    setEmployeeData(prev => ({ ...prev, [field]: file }));
                }
            } else {
                setEmployeeData(prev => ({ ...prev, [field]: file }));
            }
        } catch (error) {
            console.error('Error handling file upload:', error);
            showNotification('error', 'Error', 'Failed to process file');
        }
    };
    const handleSubmitEmployee = async () => {
        try {
            showLoader(true);

            // Validate required fields
            if (!employeeData.firstname) {
                throw new Error('First name, last name, and email are required fields');
            }

            // Prepare employee data
            let docData = {
                doctype: "Employee",
                // naming_series: employeeData.employeeId || "HR-EMP-",
                status: employeeData.status || "Active",
                company: selLocation[0],
                salary_currency: "INR",
                salary_mode: "Cash",
                first_name: employeeData.firstname,
                default_shift: employeeData.shift, // Correctly mapped from state
                last_name: employeeData.lastname,
                gender: employeeData.gender,
                branch: employeeData.branch,
                date_of_birth: employeeData.dob,
                personal_email: employeeData.email,
                cell_number: employeeData.phone,
                emergency_phone_number: employeeData.emergencyContact,
                person_to_be_contacted: employeeData.emergencyContactperson,
                relation: employeeData.Contactpersonrelationship,
                blood_group: employeeData.bloodGroup,
                current_address: employeeData.address,
                permanent_address: employeeData.paddress,
                custom_aadhar: employeeData.aadhaarNumber,
                custom_uan: employeeData.UAN,
                provident_fund_account: employeeData.PF,
                date_of_joining: employeeData.hireDate,
                relieving_date:employeeData.DOexit,
                designation: employeeData.position,
                department: employeeData.department,
                employment_type: employeeData.employmentType,
                ctc: employeeData.salary,
                // bio: employeeData.aadhaarNumber,
                pan_number: employeeData.panCardNumber,
                bank_ac_no: employeeData.bankAccountNumber,
                bank_name: employeeData.bankName,
                ifsc_code: employeeData.ifscCode,
                attachments: employeeData.documents.filter(doc => doc.file_url)
            };

            let response;
            let employeeName = employeeId;

            // Step 1: Create or Update Employee (without photo first)
            if (editMode && employeeId) {
                response = await updateEmployee(employeeId, docData);
            } else {
                if (employeeData.employeeId) {
                    docData["name"] = employeeData.employeeId;
                }
                const createRes = await createEmployee({
                    doc: JSON.stringify(docData),
                    action: 'Save'
                });
                response = createRes;
                employeeName = createRes?.data?.message?.name; // Get the generated employee ID
            }

            // Step 2: Handle profile photo upload/update if exists
            if (employeeData.photo && employeeName) {
                try {
                    // Case 1: New file upload (File/Blob object)
                    if (employeeData.photo instanceof File || employeeData.photo instanceof Blob) {
                        const uploadRes = await uploadEmployeeFile(employeeData.photo, employeeName);
                        const fileUrl = uploadRes?.data?.message?.file_url;

                        if (fileUrl) {
                            // Update employee record with new image URL
                            await updateEmployee(employeeName, { image: fileUrl });
                            setImageUrl(fileUrl);
                        }
                    }
                    // Case 2: Existing URL (string)
                    else if (typeof employeeData.photo === 'string') {
                        // If it's a blob URL, we need to re-upload it to get a persistent URL
                        if (employeeData.photo.startsWith('blob:')) {
                            // Fetch the blob and upload it
                            const blobResponse = await fetch(employeeData.photo);
                            const blob = await blobResponse.blob();
                            const uploadRes = await uploadEmployeeFile(blob, employeeName);
                            const fileUrl = uploadRes?.data?.message?.file_url;

                            if (fileUrl) {
                                await updateEmployee(employeeName, { image: fileUrl });
                                setImageUrl(fileUrl);
                            }
                        } else {
                            // It's already a proper URL, just update the reference
                            await updateEmployee(employeeName, { image: employeeData.photo });
                            setImageUrl(employeeData.photo);
                        }
                    }
                } catch (uploadError) {
                    console.error('Error handling profile image:', uploadError);
                    showNotification(
                        'warning',
                        'Profile Image Warning',
                        'Employee saved but there was an issue with the profile image'
                    );
                }
            }

            // Step 3: Handle document attachments if in edit mode
            if (editMode && employeeName) {
                try {
                    // Filter out newly uploaded documents that need attachment
                    const newDocs = employeeData.documents.filter(doc => doc.isNew && !doc.attached);

                    if (newDocs.length > 0) {
                        await Promise.all(newDocs.map(async doc => {
                            await updateFileAttachment({
                                fileName: doc.name,
                                attached_to_doctype: "Employee",
                                attached_to_name: employeeName
                            });
                        }));
                    }
                } catch (attachmentError) {
                    console.error('Error attaching documents:', attachmentError);
                    showNotification(
                        'warning',
                        'Document Attachment Warning',
                        'Employee saved but there was an issue attaching some documents'
                    );
                }
            }

            // Show success notification
            showNotification(
                'success',
                'Success',
                editMode ? 'Employee updated successfully' : 'Employee created successfully'
            );

            // Navigate back to employee list
            navigate('/employee/list');

        } catch (error) {
            console.error('Error saving employee:', error);
            let errorMessage = 'Failed to save employee';

            // Parse Frappe server messages if available
            if (error.response?.data?._server_messages) {
                try {
                    const messages = JSON.parse(error.response.data._server_messages);
                    errorMessage = messages.map(msg => {
                        try {
                            const parsed = JSON.parse(msg);
                            return parsed.message.replace(/<[^>]+>/g, '');
                        } catch {
                            return msg;
                        }
                    }).join(', ');
                } catch (parseError) {
                    console.error('Error parsing server messages:', parseError);
                }
            } else if (error.message) {
                errorMessage = error.message;
            }

            showNotification('error', 'Error', errorMessage);
        } finally {
            hideLoader();
        }
    };

    const fetchEmployeeDetails = async (employeeId) => {
        try {
            showLoader(true);
            const response = await getEmployeeDetails(employeeId);

            if (response.data && response.data.docs && response.data.docs.length > 0) {
                const empData = response.data.docs[0];
                const employeeData = {
                    firstname: empData.first_name || '',
                    shift: empData.default_shift || '', // Only one assignment needed
                    lastname: empData.last_name || '',
                    email: empData.personal_email || '',
                    phone: empData.cell_number || '',
                    employeeId: empData.name || '',
                    dob: empData.date_of_birth || '',
                    gender: empData.gender || '',
                    address: empData.current_address || '',
                    paddress: empData.permanent_address || '',
                    branch: empData.branch,
                    shift: empData.default_shift,
                    department: empData.department || '',
                    documents: empData.attachments || [],
                    position: empData.designation || '',
                    employmentType: empData.employment_type || '',
                    hireDate: empData.date_of_joining || '',
                    status: empData.status || 'Active',
                    salary: empData.ctc || '',
                    panCardNumber: empData.pan_number || '',
                    aadhaarNumber: empData.custom_aadhar || '',
                    bankAccountNumber: empData.bank_ac_no || '',
                    bankName: empData.bank_name || '',
                    ifscCode: empData.ifsc_code || '',
                    UAN: empData.custom_uan|| '',
                    PF:empData.provident_fund_account || '',
                    DOexit:empData.relieving_date || '',
                    bloodGroup: empData.blood_group || '',
                    emergencyContactperson: empData.person_to_be_contacted || '',
                    Contactpersonrelationship: empData.relation || '',
                    emergencyContact: empData.emergency_phone_number || '',
                    notes: empData.notes || '',
                    modified: empData.modified,
                    photo: empData.image || null

                };

                if (empData.image) {
                    // Construct proper image URL based on your API structure
                    let imageUrl;
                    if (empData.image.startsWith('http')) {
                        imageUrl = empData.image;
                    } else if (empData.image.startsWith('/private/files/')) {
                        // For private files, we'll need to fetch through API
                        imageUrl = await fetchProfileImageThroughApi(employeeId);
                    } else {
                        // Default case - construct URL based on your API structure
                        imageUrl = `${window.location.origin}/files/${empData.image}`;
                    }

                    if (imageUrl) {
                        setImageUrl(imageUrl);
                        setEmployeeData(prev => ({
                            ...prev,
                            photo: imageUrl
                        }));
                    }
                }
                return employeeData;
            }
            return null;
        } catch (error) {
            console.error('Error fetching employee details:', error);
            showNotification('error', 'Error', 'Failed to fetch employee details');
            return null;
        } finally {
            hideLoader();
        }
    };

    useEffect(() => {
        if (editMode && employeeId) {
            const loadEmployeeData = async () => {
                const data = await fetchEmployeeDetails(employeeId);
                if (data) {
                    setEmployeeData(data);
                    setExistingEmployee(data);
                }
            };
            loadEmployeeData();
        }
    }, [editMode, employeeId]);
    useEffect(() => {
        return () => {
            if (imageUrl && imageUrl.startsWith('blob:')) {
                URL.revokeObjectURL(imageUrl);
            }
        };
    }, [imageUrl]);

    useEffect(() => {
        if (editMode && employeeId) {
            const fetchAttachments = async () => {
                try {
                    showLoader();
                    const response = await getEmployeeAttachments(employeeId);
                    console.log('Raw attachments response:', response.data); // Debug log

                    const docs = response.data.data.map(doc => ({
                        ...doc,
                        view_url: getDocumentViewUrl(doc.file_url)
                    }));

                    console.log('Processed attachments:', docs); // Debug log
                    setAttachments(docs);
                } catch (error) {
                    console.error('Error fetching attachments:', error);
                    showNotification('error', 'Error', 'Failed to fetch attachments');
                } finally {
                    hideLoader();
                }
            };
            fetchAttachments();
        }
    }, [editMode, employeeId]);

    const fetchProfilePhoto = async (employeeId) => {
        try {
            const response = await getEmployeeProfilePhoto(employeeId);
            if (response.data.data && response.data.data.length > 0) {
                const photoData = response.data.data[0];
                setImageUrl(photoData.file_url);
            }
        } catch (error) {
            console.error('Error fetching profile photo:', error);
        }
    };

    // Call it when needed
    useEffect(() => {
        if (employeeId) {
            fetchProfilePhoto(employeeId);
        }
    }, [employeeId]);

    const fetchProfileImageThroughApi = async (employeeId) => {
        try {
            showLoader();
            // First try to get the image URL from the employee document
            const employeeResponse = await getEmployeeDetails(employeeId);
            const imageUrl = employeeResponse.data.docs[0]?.image;

            if (!imageUrl) return null;

            // If it's a direct URL, use it
            if (imageUrl.startsWith('http')) {
                return imageUrl;
            }

            // For private files, we need to fetch through API
            const response = await retrievefile(imageUrl);

            if (response.status === 200) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = URL.createObjectURL(blob);
                return url;
            }
        } catch (error) {
            console.error('Error fetching profile image:', error);
            // Fallback to default image or handle error
        } finally {
            hideLoader();
        }
        return null;
    };
    return (
        <Box
            sx={{
                width: '100%',
                p: { xs: 1, sm: 2 },
                boxSizing: 'border-box'
            }}
        >
            <Paper
                elevation={3}
                sx={{
                    width: '100%',
                    minHeight: 800,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    p: 3,
                    backgroundColor: "light.main",
                    borderRadius: "12px"
                }}
            >
                {/* Header Section */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <IconButton onClick={handleClose}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="subTitle" color="primary.main">
                            {editMode ? 'Update Employee' : 'Add New Employee'}
                        </Typography>
                    </Stack>

                    {editMode && employeeId && (
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 3,
                                alignItems: 'center',
                                backgroundColor: theme.palette.light.main,
                                p: 2,
                                borderRadius: 2,
                                borderLeft: '4px solid',
                                borderRight: '4px solid',
                                borderColor: 'primary.main',
                                boxShadow: '0px 2px 8px rgba(0,0,0,0.05)',
                                position: 'absolute',
                                left: '50%',
                                transform: 'translateX(-50%)',
                            }}
                        >
                            <Box display="flex" alignItems="center" gap={1}>
                                <BadgeIcon color="primary" fontSize="small" />
                                <Typography variant="subtitle2" color="text.primary">
                                    <Box component="span" sx={{ fontWeight: 600, color: 'text.secondary' }}>Employee ID:</Box>
                                    <Box component="span" sx={{ ml: 1 }}>{employeeData.employeeId}</Box>
                                </Typography>
                            </Box>

                            <Box display="flex" alignItems="center" gap={1}>
                                <PersonIcon color="primary" fontSize="small" />
                                <Typography variant="subtitle2" color="text.primary">
                                    <Box component="span" sx={{ fontWeight: 600, color: 'text.secondary' }}>Employee Name:</Box>
                                    <Box component="span" sx={{ ml: 1 }}>
                                        {(employeeData.firstname || '') + ' ' + (employeeData.lastname || '')}
                                    </Box>
                                </Typography>
                            </Box>
                        </Box>
                    )}

                    <Box>
                        <Button
                            onClick={handleClose}
                            variant="outlined"
                            sx={{ borderRadius: '8px', textTransform: 'none', px: 3, mr: 2 }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            sx={{ borderRadius: '8px', textTransform: 'none', px: 3 }}
                            onClick={handleSubmitEmployee}
                        >
                            {editMode ? 'Update Employee' : 'Save Employee'}
                        </Button>
                    </Box>
                </Box>

                <Divider sx={{ mb: 3 }} />

                {/* Tabs */}
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        sx={{
                            '& .MuiTab-root': { textTransform: 'none' }
                        }}
                    >
                        <Tab label="Personal Information" />
                        <Tab label="Financial Information" />
                        <Tab label="Other Information" />
                        {editMode && <Tab label="Attendance Status" />}
                    </Tabs>

                </Box>

                {/* Tab Content */}
                <Box sx={{ flex: 1, overflowY: 'auto' }}>
                    {tabValue === 0 && (
                        <Grid container spacing={3}>
                            {/* Left Column - Photo Upload (size=4) */}
                            <Grid size={4}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 2,
                                        position: 'sticky',
                                        top: 20,
                                        height: '100%'
                                    }}
                                >
                                    {/* Photo Preview */}
                                    {/* Photo Preview */}
                                    {imageUrl ? (
                                        <Box sx={{
                                            width: '100%',
                                            height: 250,
                                            borderRadius: '4px',
                                            overflow: 'hidden',
                                            border: '2px solid #eee',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: '#f5f5f5'
                                        }}>
                                            <img
                                                src={imageUrl}
                                                alt="Employee Preview"
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                                onError={(e) => {
                                                    e.target.onerror = null;
                                                    e.target.src = '/path/to/default/image.png';
                                                }}
                                            />
                                        </Box>
                                    ) : (
                                        <Box sx={{
                                            width: '100%',
                                            height: 250,
                                            borderRadius: '4px',
                                            backgroundColor: '#f5f5f5',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            border: '2px dashed #ddd'
                                        }}>
                                            <PhotoCameraIcon color="action" fontSize="large" />
                                        </Box>
                                    )}
                                    {/* Upload Controls */}
                                    <Box sx={{ width: '100%', textAlign: 'center' }}>
                                        <input
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                            id="employee-photo-upload"
                                            type="file"
                                            onChange={(e) => handleFileUpload('photo', e?.target?.files[0])}
                                        />
                                        <label htmlFor="employee-photo-upload">
                                            <Button
                                                variant="outlined"
                                                component="span"
                                                startIcon={<CloudUploadIcon />}
                                                fullWidth
                                                sx={{ mb: 1 }}
                                            >
                                                {imageUrl || employeeData.photo ? 'Change Photo' : 'Upload Photo'}
                                            </Button>
                                        </label>

                                    </Box>

                                    {/* Additional Fields Below Photo */}
                                    <Grid container spacing={3} sx={{ width: '100%', mt: 3.4 }}>
                                        <Grid size={12}>
                                            <StyledSelect
                                                label="Employment Type"
                                                value={employeeData.employmentType}
                                                onChange={(e) => handleChange('employmentType', e.target.value)}
                                                options={employmentTypeOptions}
                                                required
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid size={12}>
                                            <StyledAutocomplete
                                                label="Shift "
                                                options={shiftOptions}
                                                value={shiftOptions.includes(employeeData.shift) ? employeeData.shift : ''}
                                                onChange={(e, newValue) => handleChange('shift', newValue)}
                                                required
                                                fullWidth
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <WorkIcon color="action" />
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>

                            {/* Right Column - Form Fields (size=8) */}
                            <Grid size={8}>
                                {/* First Two Rows (3 fields each) */}
                                <Grid container spacing={3}>
                                    {/* First Row */}
                                    <Grid size={3}>
                                        <StyledTextField
                                            label="Employee ID"
                                            value={employeeData.employeeId}
                                            onChange={(e) => handleChange('employeeId', e.target.value)}
                                            required
                                            fullWidth
                                            disabled={true}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <BadgeIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={5}>
                                        <StyledTextField
                                            label="First Name *"
                                            value={employeeData.firstname}
                                            onChange={(e) => handleChange('firstname', e.target.value)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <PersonIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Last Name "
                                            value={employeeData.lastname}
                                            onChange={(e) => handleChange('lastname', e.target.value)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <PersonIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>

                                    {/* Second Row */}
                                    <Grid size={4}>
                                        <StyledAutocomplete
                                            label="Gender *"
                                            options={genderOptions}
                                            value={genderOptions.includes(employeeData.gender) ? employeeData.gender : ''}
                                            onChange={(e, newValue) => handleChange('gender', newValue)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <WorkIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Date of Birth *"
                                            type="date"
                                            value={employeeData.dob}
                                            onChange={(e) => handleChange('dob', e.target.value)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <DateRangeIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Email "
                                            type="email"
                                            value={employeeData.email}
                                            onChange={(e) => handleChange('email', e.target.value)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <EmailIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                </Grid>

                                {/* Additional Fields Below */}
                                <Grid container spacing={3} sx={{ mt: 3 }}>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Phone Number"
                                            value={employeeData.phone}
                                            onChange={(e) => handleChange('phone', e.target.value)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <PhoneIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={8}>
                                        <StyledTextField
                                            label="Address"
                                            value={employeeData.address}
                                            onChange={(e) => handleChange('address', e.target.value)}
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <HomeIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={8}>
                                        <StyledTextField
                                            label="Perment Address"
                                            value={employeeData.paddress}
                                            onChange={(e) => handleChange('paddress', e.target.value)}
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <HomeIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>

                                    <Grid size={4}>
                                        <StyledAutocomplete
                                            label="Department "
                                            options={departmentOptions}
                                            value={departmentOptions.includes(employeeData.department) ? employeeData.department : ''}
                                            onChange={(e, newValue) => handleChange('department', newValue)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <WorkIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>

                                    <Grid size={4}>
                                        <StyledAutocomplete
                                            label="Branch "
                                            options={BranchOptions}
                                            value={BranchOptions.includes(employeeData.branch) ? employeeData.branch : ''}
                                            onChange={(e, newValue) => handleChange('branch', newValue)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <WorkIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledAutocomplete
                                            label="Designation "
                                            options={positionOptions}
                                            value={positionOptions.includes(employeeData.position) ? employeeData.position : ''}
                                            onChange={(e, newValue) => handleChange('position', newValue)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <WorkIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledSelect
                                            label="Employment Status"
                                            value={employeeData.status}
                                            onChange={(e) => handleChange("status", e.target.value)}
                                            options={statusOptions}
                                            required
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid size={3}>
                                        <StyledTextField
                                            label="Date of Joining *"
                                            type="date"
                                            value={employeeData.hireDate}
                                            onChange={(e) => handleChange('hireDate', e.target.value)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <DateRangeIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={3}>
                                        <StyledTextField
                                            label="Date of Exit *"
                                            type="date"
                                            value={employeeData.DOexit}
                                            onChange={(e) => handleChange('DOexit', e.target.value)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <DateRangeIcon color="action" />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={3}>
                                        <StyledTextField
                                            label="CTC "
                                            value={employeeData.salary}
                                            onChange={(e) => handleChange('salary', e.target.value)}
                                            required
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Typography color="textSecondary" fontWeight="bold">₹</Typography>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    {tabValue === 1 && (
                        <Grid container spacing={3}>
                            <Grid size={4}>
                                <StyledTextField
                                    label="Aadhaar Number"
                                    value={employeeData.aadhaarNumber}
                                    onChange={(e) => handleChange('aadhaarNumber', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <BadgeIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid size={4}>
                                <StyledTextField
                                    label="PAN Card Number"
                                    value={employeeData.panCardNumber}
                                    onChange={(e) => handleChange('panCardNumber', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <CreditCardIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid size={4}>
                                <StyledTextField
                                    label="Bank Account Number"
                                    value={employeeData.bankAccountNumber}
                                    onChange={(e) => handleChange('bankAccountNumber', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccountBalanceIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid size={4}>
                                <StyledTextField
                                    label="Bank Name"
                                    value={employeeData.bankName}
                                    onChange={(e) => handleChange('bankName', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccountBalanceIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid size={4}>
                                <StyledTextField
                                    label="IFSC Code"
                                    value={employeeData.ifscCode}
                                    onChange={(e) => handleChange('ifscCode', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccountBalanceIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid size={4}>
                                <StyledTextField
                                    label="PF Accont No."
                                    value={employeeData.PF}
                                    onChange={(e) => handleChange('PF', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccountBalanceIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid size={4}>
                                <StyledTextField
                                    label="UAN No."
                                    value={employeeData.UAN}
                                    onChange={(e) => handleChange('UAN', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccountBalanceIcon color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Box>
                                    {/* Upload Section (only in edit mode) */}
                                    {editMode && (
                                        <Box sx={{
                                            width: '100%',
                                            p: 3,
                                            borderRadius: '4px',
                                            backgroundColor: '#f5f5f5',
                                            border: '2px dashed #ddd',
                                            mb: 2,
                                            textAlign: 'center'
                                        }}>
                                            <input
                                                accept=".pdf,.jpg,.png,.jpeg,.doc,.docx"
                                                style={{ display: 'none' }}
                                                id="document-upload"
                                                type="file"
                                                multiple
                                                onChange={(e) => handleMultipleDocumentUpload(e.target.files)}
                                            />
                                            <label htmlFor="document-upload">
                                                <Button
                                                    variant="outlined"
                                                    component="span"
                                                    startIcon={<CloudUploadIcon />}
                                                >
                                                    Upload Documents
                                                </Button>
                                            </label>
                                            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
                                                Max file size: 10MB | Supported formats: PDF, JPG, PNG, DOC
                                            </Typography>
                                        </Box>
                                    )}

                                    {/* Attachments List */}
                                    {attachments.length > 0 && (
                                        <Box mt={3}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Attached Documents
                                            </Typography>
                                            <List dense>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                                                    {attachments.map((attachment, index) => {
                                                        // Extract filename from attachment object or URL as fallback
                                                        const fileName = attachment.file_name ||
                                                            attachment.name ||
                                                            (attachment.file_url ? attachment.file_url.split('/').pop() : 'document');

                                                        // Extract file extension for display
                                                        const fileExt = fileName.split('.').pop().toUpperCase();
                                                        const displayName = fileName.length > 20 ?
                                                            `${fileName.substring(0, 15)}...${fileExt}` :
                                                            fileName;

                                                        return (
                                                            <Chip
                                                                key={index}
                                                                label={displayName}
                                                                onClick={async () => {
                                                                    try {
                                                                        const response = await retrievefile(attachment.file_url);
                                                                        const blob = new Blob([response.data], { type: response.headers['content-type'] });

                                                                        // Extract filename from content-disposition header if available
                                                                        let downloadName = fileName;
                                                                        const contentDisposition = response.headers['content-disposition'];
                                                                        if (contentDisposition) {
                                                                            const matches = contentDisposition.match(/filename="?([^"]+)"?/);
                                                                            if (matches && matches[1]) {
                                                                                downloadName = matches[1];
                                                                            }
                                                                        }

                                                                        // Try to open directly if it's an image or PDF
                                                                        if (response.headers['content-type'].match(/(image\/|application\/pdf)/)) {
                                                                            const fileURL = URL.createObjectURL(blob);
                                                                            const openedWindow = window.open(fileURL, '_blank');

                                                                            // If popup was blocked, fall back to download
                                                                            if (!openedWindow || openedWindow.closed || typeof openedWindow.closed === 'undefined') {
                                                                                throw new Error('Popup blocked - falling back to download');
                                                                            }

                                                                            // Clean up after the window is closed
                                                                            openedWindow.onload = () => {
                                                                                setTimeout(() => URL.revokeObjectURL(fileURL), 1000);
                                                                            };
                                                                        } else {
                                                                            // For other file types, force download
                                                                            const url = window.URL.createObjectURL(blob);
                                                                            const link = document.createElement('a');
                                                                            link.href = url;
                                                                            link.setAttribute('download', downloadName);
                                                                            document.body.appendChild(link);
                                                                            link.click();
                                                                            link.remove();
                                                                            setTimeout(() => window.URL.revokeObjectURL(url), 100);
                                                                        }
                                                                    } catch (err) {
                                                                        console.error('Error handling file:', err);
                                                                        showNotification('error', 'File Error', 'Could not open the file');
                                                                    }
                                                                }}
                                                                sx={{
                                                                    backgroundColor: theme.palette.secondary.main,
                                                                    color: theme.palette.primary.main,
                                                                    cursor: 'pointer',
                                                                    maxWidth: 200,
                                                                    '& .MuiChip-label': {
                                                                        overflow: 'hidden',
                                                                        textOverflow: 'ellipsis',
                                                                        whiteSpace: 'nowrap'
                                                                    }
                                                                }}
                                                            />
                                                        );
                                                    })}
                                                </Box>
                                            </List>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    )}

                    {tabValue === 2 && (
                        <Grid container spacing={3}>
                            <Grid size={4}>
                                <StyledTextField
                                    label="Emergency Contact Person"
                                    value={employeeData.emergencyContactperson}
                                    onChange={(e) => handleChange('emergencyContactperson', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PersonIcon color="action" />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid size={4}>
                                <StyledTextField
                                    label="Contact Person Relationship"
                                    value={employeeData.Contactpersonrelationship}
                                    onChange={(e) => handleChange('Contactpersonrelationship', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PersonIcon color="action" />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid size={4}>
                                <StyledTextField
                                    label="Emergency Contact"
                                    value={employeeData.emergencyContact}
                                    onChange={(e) => handleChange('emergencyContact', e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <PhoneIcon color="action" />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid size={4}>
                                <StyledSelect
                                    label="Blood Group"
                                    value={employeeData.bloodGroup}
                                    onChange={(e) => handleChange('bloodGroup', e.target.value)}
                                    options={bloodGroups}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <BloodtypeIcon color="action" />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>

                        </Grid>
                    )}
                    {tabValue === 3 && (
                        <Grid size={12}>
                            <Paper
                                elevation={0}
                                sx={{
                                    p: 3,
                                    borderRadius: 3,
                                    backgroundColor: '#f8fbff',
                                    border: '1px solid #e0e8f5',
                                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
                                }}
                            >
                                <Grid container spacing={2} alignItems="center" justifyContent="space-between" mb={3}>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main' }}>
                                            Employee Attendance Overview
                                        </Typography>
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
                                            <Grid item xs={12} sm={5} md={4}>
                                                <StyledTextField
                                                    fullWidth
                                                    label="Start Date"
                                                    type="date"
                                                    value={startDate}
                                                    onChange={(e) => setStartDate(e.target.value)}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <DateRangeIcon color="action" />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={5} md={4}>
                                                <StyledTextField
                                                    fullWidth
                                                    label="End Date"
                                                    type="date"
                                                    value={endDate}
                                                    onChange={(e) => setEndDate(e.target.value)}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <DateRangeIcon color="action" />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={2} md={4}>
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    color="primary"
                                                    sx={{
                                                        borderRadius: '8px',
                                                        textTransform: 'none',
                                                        px: 3,
                                                        mt: { xs: 0, sm: 3 }
                                                    }}
                                                    onClick={fetchAttendanceData}
                                                >
                                                    Apply
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2} mt={5}>
                                    <Grid size={2.4}>
                                        <Paper elevation={0} sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            backgroundColor: 'light.main',
                                            border: '1px solid #e0e8f5',
                                            height: '100%',
                                            minWidth: 250,
                                        }}>
                                            <Box display="flex" alignItems="center" gap={2}>
                                                <Box sx={{
                                                    p: 1.5,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#e3f2fd',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    <CalendarTodayIcon color="primary" fontSize="small" />
                                                </Box>
                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">Total Days</Typography>
                                                    <Typography variant="subtitle1" fontWeight={600}>{attendanceStats.workingDays} Days</Typography>
                                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                                        {dayjs(startDate).format('DD MMM')} - {dayjs(endDate).format('DD MMM YYYY')}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>

                                    <Grid size={2.4}>
                                        <Paper elevation={0} sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            backgroundColor: 'light.main',
                                            border: '1px solid #e0e8f5',
                                            height: '100%',
                                            minWidth: 250,
                                        }}>
                                            <Box display="flex" alignItems="center" gap={2}>
                                                <Box sx={{
                                                    p: 1.5,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#e8f5e9',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    <EventAvailableIcon color="success" fontSize="small" />
                                                </Box>
                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">Present Days</Typography>
                                                    <Typography variant="subtitle1" fontWeight={600}>{attendanceStats.presentDays} Days</Typography>
                                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                                        {attendanceStats.presentDays > 0 ? `${attendanceStats.avgWorkingHours} hrs/day avg` : '-'}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>

                                    <Grid size={2.4}>
                                        <Paper elevation={0} sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            backgroundColor: 'light.main',
                                            border: '1px solid #e0e8f5',
                                            height: '100%',
                                            minWidth: 250,
                                        }}>
                                            <Box display="flex" alignItems="center" gap={2}>
                                                <Box sx={{
                                                    p: 1.5,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#ffebee',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    <EventBusyIcon color="error" fontSize="small" />
                                                </Box>
                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">Absent Days</Typography>
                                                    <Typography variant="subtitle1" fontWeight={600}>{attendanceStats.absentDays} Days</Typography>
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>



                                    <Grid size={2.4}>
                                        <Paper elevation={0} sx={{
                                            p: 2,
                                            borderRadius: 2,
                                            backgroundColor: 'light.main',
                                            border: '1px solid #e0e8f5',
                                            height: '100%',
                                            minWidth: 250,
                                        }}>
                                            <Box display="flex" alignItems="center" gap={2}>
                                                <Box sx={{
                                                    p: 1.5,
                                                    borderRadius: '50%',
                                                    backgroundColor: '#f3e5f5',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                    <DonutLargeIcon color="secondary.main" fontSize="small" />
                                                </Box>
                                                <Box>
                                                    <Typography variant="caption" color="text.secondary">Attendance Rate</Typography>
                                                    <Typography variant="subtitle1" fontWeight={600}>{attendanceStats.attendanceRate}%</Typography>
                                                </Box>
                                            </Box>
                                        </Paper>
                                    </Grid>
                                </Grid>

                                <Box sx={{ flex: 1, mt: 3 }}>
                                    <BasicTable
                                        data={employeeTableConfig}
                                        search={searchQuery}
                                        backgroundColor="#f9fafc"
                                    />
                                </Box>
                            </Paper>
                        </Grid>
                    )}
                </Box>
            </Paper >
        </Box >
    );
}

export default AddEmployee;